import { useCallback } from 'react';
import { useUiStore } from './index';
import { ORDER_STATUS_LABELS, translate, type MessageKey } from './messages';

/**
 * `const t = useT()` — the translator bound to the active language.
 *
 * A hook rather than a context provider: the language already lives in a store,
 * and a provider would only add a second place for it to disagree with itself.
 */
export function useT() {
  const locale = useUiStore((state) => state.locale);

  return useCallback(
    (key: MessageKey, values?: Record<string, string | number>) => translate(key, locale, values),
    [locale],
  );
}

/** Order status in the active language, falling back to the raw enum. */
export function useStatusLabel() {
  const locale = useUiStore((state) => state.locale);

  return useCallback(
    // A pickup that reached DELIVERED was collected, and says so (R6).
    (status: string, isPickup = false) =>
      isPickup && status === 'DELIVERED'
        ? translate('collected', locale)
        : (ORDER_STATUS_LABELS[status]?.[locale] ?? status),
    [locale],
  );
}
